import { useNavigation } from "@react-navigation/native";
import { useState } from "react";
import { StyleSheet, TouchableWithoutFeedback, View } from "react-native";
import { FontAwesome5 } from "@expo/vector-icons";
import { Colors } from "../../styles";
import { Entity, Icon, InsightID } from "../../types/data";
import { entityIcon } from "../../utils/data";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigators/StackNavigator";
import { useDispatch, useSelector } from "react-redux";
import {
  selectStoryViewed,
  setEntity,
  setViewingStory,
} from "../../redux/mainSlice";
import { RootState } from "../../redux";

interface Props {
  entity: Entity;
  insights: InsightID[];
}

const StoryIcon = ({ entity, insights }: Props) => {
  const dispatch = useDispatch();
  const navigation = useNavigation<RootStackParamList>();

  const viewed = useSelector((state: RootState) =>
    selectStoryViewed(state, entity)
  );

  if (insights.length === 0) return <></>;
  return (
    <TouchableWithoutFeedback
      onPress={() => {
        dispatch(setEntity(entity));
        dispatch(setViewingStory(entity));
        // navigation.navigate("Story", { entity, ids: insights });
      }}
    >
      <View style={[styles.container, viewed && styles.viewedContainer]}>
        <FontAwesome5
          name={entityIcon(entity)}
          size={20}
          color={Colors.white}
        />
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 46,
    height: 46,
    borderRadius: 46 / 2,
    borderColor: Colors.teal700,
    borderWidth: 1,
    marginRight: 8,
    justifyContent: "center",
    alignItems: "center",
  },
  viewedContainer: {
    opacity: 0.5,
    borderColor: Colors.white,
  },
});

export default StoryIcon;
